import { render } from "./MarketingPage.vue?vue&type=template&id=5c17fea2&scoped=true"
import script from "./MarketingPage.vue?vue&type=script&lang=js"
export * from "./MarketingPage.vue?vue&type=script&lang=js"

import "./MarketingPage.vue?vue&type=style&index=0&id=5c17fea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c17fea2"]])

export default __exports__